import React, { useState } from 'react';
import { Box, Button, Heading, Input, VStack, Text, Link, FormControl, FormLabel, Alert, AlertIcon } from '@chakra-ui/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useCheckAuth from '../hooks/useCheckAuth';
import { Helmet } from "react-helmet";

const RegisterPage = () => {
  useCheckAuth(true);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');  // For success feedback
  const [loading, setLoading] = useState(false);  // For loading state
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);  // Start loading
    setError('');  // Clear error state
    setSuccessMessage('');  // Clear success state

    try {
      const response = await axios.post('/api/register', { name, email, password });

      // If registration is successful, display a success message
      if (response.status === 201) {
        setSuccessMessage('Registration successful! Redirecting to login...');
        setTimeout(() => {
          navigate('/login');  // Redirect after 3 seconds
        }, 3000);  // 3-second delay for user to see success message
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 409) {
          setError('User already exists');  // Specific error for 409 Conflict
        } else if (err.response.status === 400) {
          setError('Invalid input');  // Specific error for 400 Bad Request
        } else {
          setError('Error: ' + err.response.data.message);  // Other errors
        }
      } else {
        setError('Server error: ' + err.message);  // For network errors
      }
    } finally {
      setLoading(false);  // Stop loading
    }
  };

  return (
    <>
      <Helmet>
        <title>Register an Account with Us</title>
        <meta name="description" content="Register your account" />
      </Helmet>

      <Box maxW="md" mx="auto" mt={8} p={6} borderWidth={1} borderRadius="lg">
        <Heading mb={6} textAlign="center">Register</Heading>


        {successMessage && (
          <Alert status="success" mb={4}>
            <AlertIcon />
            {successMessage}
          </Alert>
        )}

        {error && (
          <Alert status="error" mb={4}>
            <AlertIcon />
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Password</FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
              />
            </FormControl>

            <Button
              type="submit"
              colorScheme="orange"
              width="full"
              isLoading={loading}  // Loading state
            >
              Register
            </Button>

            <Text>
              Already have an account?{' '}
              <Link as={RouterLink} to="/login" color="blue.500">
                Login
              </Link>
            </Text>
          </VStack>
        </form>
      </Box>
    </>
  );
};

export default RegisterPage;
